import React from "react";
import { Navigate } from "react-router-dom";
import { getSession, isTokenExpired } from "../utils/auth";

export default function ProtectedRoute({ children }) {

    const session = getSession();

    // Si no hay sesión → al login
    if (!session || !session.token) {
        return <Navigate to="/" replace />;
    }

    // Si el token expiró → limpiar y redirigir
    if (isTokenExpired(session.token)) {
        localStorage.removeItem("odoo_session");
        return <Navigate to="/" replace />;
    }

    // Si todo está ok → mostrar la vista
    return children;
}